import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

function DetailsTopBar({ tabs =[], activeTab, agent}) {

  const navigate = useNavigate();

  const handleClick = (tab) => {
    if (tab.path) {
        navigate(tab.path, {state: {agent}});
    } else if (tab.onClick) {
        tab.onClick();
    }
  };

  return (
    <div className="top-bar">
          {/* tap buttons */}
          <div className="top-buttons" style={{width:"200px"}}>
            {tabs.map((tab, index) => (
                <button
                    key={index}
                    className={`tab-btn ${activeTab === tab.key ? "active" : ""}`}
                    onClick={() => handleClick(tab)}
                >
                    {tab.label}
                </button>
            ))}
          </div>
    </div>
  );
}

export default DetailsTopBar